import { Action } from 'typescript-fsa';
import { fetchWrapperFunc } from '../../../utils';
import { getCacheApi, ServerType } from '../../System/systemConfig';
import { cacheSet, CACHE_LOAD, CACHE_CLEAR, CACHE_CLEAR_ALL, cacheSetAvailable } from './actions';
import { takeLatest, all } from 'redux-saga/effects';

function* loadCacheGenerator(action: Action<ServerType>) {
    const serverName = action.payload;

    yield* fetchWrapperFunc(
        () => getCacheApi(serverName).getCacheViews(),
        [r => cacheSet({ serverName, caches: r })],
        () => cacheSetAvailable({ serverName, available: false })
    );
}

function* clearCacheGenerator(action: Action<{ serverName: ServerType; cache: string }>) {
    const serverName = action.payload.serverName;
    const cacheId = action.payload.serverName;

    yield* fetchWrapperFunc(
        () => getCacheApi(serverName).clearCache(cacheId ),
        [r => cacheSet({ serverName, caches: r })],
        () => cacheSetAvailable({ serverName, available: false })
    );
}

function* clearAllCachesGenerator(action: Action<ServerType>) {
    const serverName = action.payload;

    yield* fetchWrapperFunc(
        () => getCacheApi(serverName).clearAllCaches(),
        [r => cacheSet({ serverName, caches: r })],
        () => cacheSetAvailable({ serverName, available: false })
    );
}

function* watchForCacheActions() {
    yield takeLatest(CACHE_LOAD, loadCacheGenerator);
    yield takeLatest(CACHE_CLEAR, clearCacheGenerator);
    yield takeLatest(CACHE_CLEAR_ALL, clearAllCachesGenerator);
}

export function* cacheSagas() {
    yield all([watchForCacheActions()]);
}
